export default [
  {
    path: '/formbuilder',
    component: require('../views/formbuilder/pages/index').default,
    meta: { validate: ['auth', 'two_factor', 'lock_screen'] },
    children: [
      {
        path: '',
        name: 'formbuilder.main',
        component: require('../views/formbuilder/pages/intro').default
      },
      {
        path: 'form',
        component: require('../views/formbuilder/pages/form_list').default
      },
      {
        path: 'form/config/:id?',
        component: require('../views/formbuilder/pages/form_config').default
      },
      {
        path: 'record',
        component: require('../views/formbuilder/pages/record_list').default
      }
    ]
  }
];
